export default __webpack_public_path__ + "static/grenade_launcher-field_forged-6e57ff.svg";